import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from "react-redux";
import Img from 'react-image'

//Components Imports
import ComponentHOC from "../hoc/ComponentHOC";
import {Link} from "react-router-dom";

//Images imports
import twitterShare from '../img/icons/twiter-whitebg-icon.png'
import facebookShare from '../img/icons/facebook-whitebg-icon.png'
import Moment from "moment";
import Post from "../models/posts";
import {MetaTags} from "react-meta-tags";

class ViewMillenialsComponent extends Component {
    constructor(props){
        super(props)
        this.state = {
            item: null
        }
    }
    componentWillMount(){
        const {list} = this.props
        list.map((item) => {
            var obj = new Post(item)
            if(obj.id === this.props.match.params.id){
                this.setState({
                    item: obj
                })
            }
        })
    }
    render(){
        const {item} = this.state
        return (
            <section className='view-millenials-section'>
                <MetaTags>
                    <title>Millennials Mafia - {item.title}</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content={`Millennials Mafia - ${item.title}`} />
                    <meta property="og:image" content={item.image_link} />
                </MetaTags>
                <div className="container">
                    <div className="row justify-content-center align-items-center main-view">
                        <div className="col-12 col-lg-6">
                            <div className="thumb">
                                {item.image_link? <Img src={item.image_link} alt={item.title}/>:<div className="video-container"><iframe width="400" height="300" src={item.video_link} frameBorder="0" allowFullScreen={true}/></div>}
                            </div>
                            <span className="label"><time dateTime={item.date}>{Moment(item.date).format('DD/MM/YYYY')}</time></span>
                            <h1>{item.title}</h1>
                            <div dangerouslySetInnerHTML={{__html: item.description}} />
                            <div className="share-bar">
                                <ul>
                                    {item.twitterLink?<li><Link to={item.twitterLink}><Img src={twitterShare} aria-hidden='true'/></Link></li>:''}
                                    {item.facebookLink?<li><Link to={item.facebookLink}><Img src={facebookShare} aria-hidden='true'/></Link></li>:''}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

ViewMillenialsComponent.propType = {
    item: PropTypes.array.isRequired,
}

export default connect(state => state)(ComponentHOC(ViewMillenialsComponent))


// WEBPACK FOOTER //
// ./src/components/view-millenials.js